<template>
  <div class="people_box">
    <sellheader></sellheader>
    <div class="content">
      <div
        :style="{ backgroundImage: 'url(' + backgroundImg + ')' }"
        style="background-size: cover; min-height: 300px; position: relative"
        class="inner-banner"
      >
        <section class="w3l-breadcrumb">
          <div class="container">
            <ul class="breadcrumbs-custom-path">
              <li><a href="./">首页</a></li>
              <li class="active">
                <span class="fa fa-chevron-right mx-2" aria-hidden="true"></span
                >人力资源
              </li>
            </ul>
          </div>
        </section>
      </div>
      <div class="peopleList">
        <div class="feed_box">
          <section class="w3l-index3" v-if="showId == 'f'" id="f">
            <div class="midd-w3 py-5">
              <div class="container py-lg-5 py-md-3">
                <div class="row">
                  <div class="col-lg-12 pl-lg-5">
                    <div v-for="(item, index) in jobList" :key="index">
                      <!-- <img style="width:100%;hight:100%" src="@/assets/images/fu.png"/> -->
                      <p class="fuli ql-editor" v-html="item.requirements"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section v-if="showId == 'jihui'" class="w3l-index3" id="jihui">
            <div style="width: 100%" class="midd-w3 py-5">
              <div style="width: 100%" class="container py-lg-5 py-md-3">
                <div class="row">
                  <div class="col-lg-12 pl-lg-5">
                    <div class="header-title">
                      <h3
                        style="line-height: 100px"
                        class="hny-title text-center"
                      >
                        工作机会
                      </h3>
                    </div>
                    <div class="joinOne_box">
                      <!-- <a
                        href="https://www.zhaopin.com/companydetail/CZ819968070.htm"
                        target="_blank"
                        class="serSix_a wgt-fade-animate"
                      >
                        <div class="joinOne_div">
                          <div class="joinOne_l">
                            <img src="../../assets/images/zhilian.png" alt="" />
                          </div>
                          <div class="joinOne_r">
                            <span>智联招聘</span>
                            <p></p>
                          </div>
                        </div>
                        <span>立即前往 &gt; </span>
                        <i>j</i>
                      </a> -->
                      <a
                        href="https://www.zhipin.com/gongsi/0ebcc2de927ad5581X190tm1EFA~.html?ka=search_rcmd_company_name_0ebcc2de927ad5581X190tm1EFA~_custompage"
                        target="_blank"
                        class="serSix_a wgt-fade-animate appear"
                      >
                        <div class="joinOne_div">
                          <div class="joinOne_l">
                            <img src="../../assets/images/boos.png" alt="" />
                          </div>
                          <div class="joinOne_r">
                            <span>BOOS直聘</span>
                            <p></p>
                          </div>
                        </div>
                        <span>立即前往 &gt; </span>
                        <i>j</i>
                      </a>
                      <a
                        href="https://www.job001.cn/companyinfo/fd028741-19fc-4fd9-bd35-08b14956fd2b.html"
                        target="_blank"
                        class="serSix_a wgt-fade-animate"
                      >
                        <div class="joinOne_div">
                          <div class="joinOne_l">
                            <img src="../../assets/images/liepin.png" alt="" />
                          </div>
                          <div class="joinOne_r">
                            <span>猎聘</span>
                            <p></p>
                          </div>
                        </div>
                        <span>立即前往 &gt; </span>
                        <i>j</i>
                      </a>
                    </div>
                    <!-- <div
                      v-for="(item, index) in jobList"
                      :key="index"
                      class="z_list"
                    >
                      <h4>{{ item.jobName }}</h4>
                      <p style="font-weight: 500">
                        招聘人数：{{ item.num }} 人
                      </p>
                      <p style="font-weight: 500">学历：{{ item.education }}</p>
                      <div>
                        <p style="font-weight: 500">岗位职责：</p>
                        <span>
                          <p class="ql-editor" v-html="item.duty"></p>
                          <p style="font-weight: 500">任职要求：</p>
                          <p class="ql-editor" v-html="item.requirements"></p>
                        </span>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="w3l-index3" v-if="showId == 'yinjin'" id="yinjin">
            <div class="midd-w3 py-5">
              <div class="container py-lg-5 py-md-3">
                <div class="row">
                  <div class="col-lg-12 pl-lg-5">
                    <div class="header-title">
                      <h3
                        style="line-height: 100px"
                        class="hny-title text-center"
                      >
                        人才引进
                      </h3>
                    </div>
                    <div v-for="(item, index) in jobList" :key="index">
                      <p class="ql-editor" v-html="item.requirements"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script>
import sellheader from "@/views/home/header/index.vue";
import footers from "@/views/footer/index.vue";
import { jobList } from "@/api/job/index";
import { bannerList } from "@/api/menu/index.js";
export default {
  components: {
    sellheader,
    footers,
  },
  data() {
    return {
      backgroundImg: "",
      jobList: [],
      imgqueryParams: {
        picType: "people",
      },
      type: 0,
      showId: "jihui",
    };
  },
  created() {
    if (this.getUrlParam("selectid") != null) {
      this.showId = this.getUrlParam("selectid");
      this.ifshowid(this.showId);
    }
  },
  watch: {
    $route(to, from) {
      this.ifshowid(to.query.selectid);
      this.showId = to.query.selectid;
    },
  },
  mounted() {
    this.getJobList();
    this.getBannerList();
    if (this.getUrlParam("selectid") != null) {
      this.showId = this.getUrlParam("selectid");
    }
  },
  methods: {
    ifshowid(type) {
      if (type == "jihui") {
        this.type = 0;
      } else if (type == "f") {
        this.type = 2;
      } else if (type == "yinjin") {
        this.type = 1;
      }
      this.getJobList();
    },

    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
      var r = window.location.search.substr(1).match(reg); //匹配目标参数
      if (r != null) return unescape(r[2]);
      return null; //返回参数值
    },

    getBannerList() {
      bannerList(this.imgqueryParams).then((res) => {
        if (res.total > 0) {
          this.backgroundImg = res.rows[0].picUrl;
        }
      });
    },
    getJobList() {
      jobList({ type: this.type }).then((res) => {
        this.jobList = res.rows;
      });
    },
  },
};
</script>


<style lang="less" scoped>
p {
  text-indent: 2em;
}
.z_list {
  width: 100%;
  margin: 40px 0px 40px 0px;
}
.fuli ::v-deep img {
  width: 90%;
  height: 100%;
}
.joinOne_box {
  display: none;
  display: flex;
  align-items: stretch;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 98%;
  margin: 0 auto;
}
.serSix_a {
  cursor: pointer;
  position: relative;
  top: -145px;
  width: 32%;
  overflow: hidden;
  display: block;
  padding: 42px 42px 108px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
  transition: all 0.48s;
  background: #e6a230;
  margin-left: 20px;
}
.serSix_a:hover {
  top: -155px;
}
.joinOne_div {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  img {
    border: 0;
    vertical-align: middle;
  }
  .joinOne_l {
    position: relative;
    text-align: right;
    width: 168px;
    margin-top: 14px;
    img {
      width: 148px;
    }
  }
  .joinOne_r {
    order: -1;
    display: inline-block;
    text-align: left;
    width: calc(100% - 168px);
    span {
      color: #fff;
      font-size: 24px;
      font-weight: bold;
      letter-spacing: 0.5px;
    }
  }
}
.serSix_a > span {
  position: absolute;
  bottom: 30px;
  right: 30px;
  color: #fff;
  text-decoration: underline;
}
.serSix_a > i {
  position: absolute;
  bottom: -90px;
  left: 5%;
  opacity: 0.68;
  font-size: 128px;
  color: #fff;
  text-transform: uppercase;
  font-weight: bold;
  font-family: "GOTHIC";
}
.appear {
  -wewgtit-animation: opacity_show 1s 1 cubic-bezier(0.445, 0.05, 0.55, 0.95)
    forwards;
  -webkit-animation: opacity_show 1s 1 cubic-bezier(0.445, 0.05, 0.55, 0.95)
    forwards;
  -moz-animation: opacity_show 1s 1 cubic-bezier(0.445, 0.05, 0.55, 0.95)
    forwards;
  -o-animation: opacity_show 1s 1 cubic-bezier(0.445, 0.05, 0.55, 0.95) forwards;
  animation: opacity_show 1s 1 cubic-bezier(0.445, 0.05, 0.55, 0.95) forwards;
  opacity: 1 !important;
}
.wgt-fade-animate {
  -webkit-transform: scale(0.3);
  -moz-transform: scale(0.3);
  -ms-transform: scale(0.3);
  -o-transform: scale(0.3);
  transform: scale(0.3);
  -webkit-transform: translateY(150px);
  -moz-transform: translateY(150px);
  -ms-transform: translateY(150px);
  -o-transform: translateY(150px);
  transform: translateY(150px);
  opacity: 1;
}
a {
  color: #fff;
  text-decoration: none;
  cursor: pointer;
}




</style>